<div class=" overflow-auto h-screen w-full">
  <app-shared-action-bar [saveReady]="unsavedChanges&&!trySave" [undoReady]="unsavedChanges"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="saveChanges()"
  [alternativeBackDestination]="backDestination" (undoRequest)="resetChanges()"></app-shared-action-bar>
  @if (audit!=undefined) {
    <div class="mt-20 px-4 md:px-8 ">
      <h1>{{audit.AuditName}}</h1>
      @if (reloading) {
        <div>
          <p>Loading...</p>
        </div>
      }
      @if (!reloading) {
        <div class="mb-8">
          <div class="flex lg:flex-row flex-col mt-8">
            <div class="w-52 border p-2 rounded-tl-md lg:rounded-tr-none rounded-tr-md lg:rounded-bl-md cursor-pointer text-center"
              [ngClass]="{'border-green-300': showMainInfo, 'border-grey-900': !showMainInfo, 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': showMainInfo}"
              (click)="showAuditMainInfo()"><span class="p-4"
            [ngClass]="{'text-green-700':showMainInfo, 'font-bold': showMainInfo}">Main Information</span>
          </div>
          <div class="w-52 border border-grey-900 p-2 cursor-pointer text-center"
            [ngClass]="{'border-green-300': showEntryOptions, 'border-grey-900': !showEntryOptions, 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': showEntryOptions}"
            (click)="showAuditEntryOptions()"><span class="p-4"
            [ngClass]="{'text-green-700':showEntryOptions, 'font-bold': showEntryOptions}">Entry
          Options</span></div>
          <!--<div class="w-52 border border-grey-900 p-2 cursor-pointer text-center"
          [ngClass]="{'border-green-300': showQuestions, 'border-grey-900': !showQuestions, 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': showQuestions}"
          (click)="showAuditQuestions()"><span class="p-4"
        [ngClass]="{'text-green-700':showQuestions, 'font-bold': showQuestions}">Questions</span></div>-->
        <div class="w-52 border border-grey-900 p-2 lg:rounded-tr-md lg:rounded-bl-none rounded-bl-md rounded-br-md cursor-pointer text-center"
          [ngClass]="{'border-green-300': showQuestions, 'border-grey-900': !showQuestions, 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': showQuestions}"
          (click)="showAuditQuestions()"><span class="p-4"
        [ngClass]="{'text-green-700':showQuestions, 'font-bold': showQuestions}">Questions</span></div>
      </div>
      @if (showMainInfo) {
        <app-edit-main-info [(audit)]="audit" [auditTypes]="auditTypes"
        (auditChange)="auditChangeCheck(false)" [frequencies]="frequencies"></app-edit-main-info>
      }
      @if (showEntryOptions) {
        <app-edit-entry-options [(audit)]="audit"
        (auditChange)="auditChangeCheck(false)"></app-edit-entry-options>
      }
      @if (showQuestions) {
        <app-edit-questions [newAudit]="newAudit" [(audit)]="audit"
        (auditChange)="auditChangeCheck(true)"></app-edit-questions>
      }
      @if (showWorkflow) {
        <app-edit-workflow [(audit)]="audit"
        (auditChange)="auditChangeCheck(false)"></app-edit-workflow>
      }
    </div>
  }
</div>
}
</div>